<template>
  <ProvideTags v-slot="{ tags }" tag-type="skills">
    <div>
      <div id="searchform" class="input-group input-group-lg">
        <VSelect
          ref="select"
          v-model="search"
          :placeholder="$t('Enter job title or skills')"
          :options="tags"
          :inline="true"
          :input-id="'searchbar'"
          :max="500"
          multiple
        />
        <a
          class="btn-success input-group-addon z-depth-0 waves-effect pointer"
          @click="forceSearch"
        >
          <span class="glyphicon glyphicon-search" aria-hidden="true" />
          &nbsp;
          {{ $t('Search') }}
        </a>
      </div>
      <TypeSuggestions
        v-show="displaySuggestions"
        ref="suggestions"
        :item-added="suggestionAdded"
        :inline="true"
      >
        <slot />
      </TypeSuggestions>
    </div>
  </ProvideTags>
</template>

<script>
import TypeSuggestions from '@/components/TypeSuggestions.vue'
import ProvideTags from '@/components/ProvideTags.vue'
import VSelect from '@/components/VSelect.vue'

export default {
  name: 'InputSearch',
  components: { TypeSuggestions, ProvideTags, VSelect },
  props: {
    refSearch: {
      type: Object,
      required: true,
    },
    refStore: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      options: [],
      displaySuggestions: false,
    }
  },
  computed: {
    // Here we create binder so that we can use a vuex store or a normal object depending on the use case
    binder: {
      get() {
        return this.refSearch.term
      },
      set(val) {
        if (this.refStore) {
          this.refStore.store.commit(this.refStore.mutator.term, val)
        } else {
          // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
          this.refSearch.term = val
        }
      },
    },
    search: {
      get() {
        const term = this.binder
        if (term) {
          return term.split(',').filter((i) => i !== '')
        }
        return []
      },
      set(value) {
        this.binder = value.join(',')
      },
    },
  },
  watch: {
    'refSearch.term': function () {
      this.updateSuggestions()
    },
  },
  mounted() {
    this.updateSuggestions()
  },
  methods: {
    forceSearch() {
      this.$refs?.select.select(this.$refs?.select.search)
    },
    updateSuggestions() {
      this.displaySuggestions = this.search.length > 0
      if (this.search.length > 0 && this.$refs.suggestions) {
        this.$refs.suggestions.suggestSkills(this.search[this.search.length - 1])
      }
    },
    suggestionAdded(item) {
      if (item.length > 0) {
        this.binder += `,${item}`
      }
    },
  },
}
</script>

<style scoped lang="scss">
.row {
  margin-left: 0px;
  margin-right: 0px;
}
#searchform {
  .dropdown {
    border: 1px solid #e0e0e0;
    border-radius: 6px 0 0 6px;
    border-right: 0;
    &:focus-within {
      border: 1.5px solid #7b61ff;
      box-shadow: 0px 0px 0px 2.5px rgba(123, 97, 255, 0.2);
      border-right: 0;
    }
  }
}
</style>
